import { Caption } from '../atoms/Text/Text';
import { styled } from '../../core/theme/styled';

export const DebuggerInfoContainer = styled.div`
  display: flex;
  background-color: transparent;
  justify-content: center;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999999;
`;

export const Info = styled.div`
  background-color: #000000;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  padding: ${(props) => props.theme.sizes.normal};
  text-align: center;
`;

export const Text = styled(Caption)`
  color: #ffffff;
  margin: 0;
  padding: 0;
`;
